module.exports = __webpack_public_path__ + "img/6_121.a816ddcd.png";